import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

import constants from '../../config/constants';
import { useMediaQuery } from '@mui/material';

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open, sideNavWidth = constants.SIDE_NAV_WIDTH }) => {
  const isMobile = useMediaQuery('(max-width:600px)');
  return {
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: sideNavWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
    },
    '& .MuiListItemButton-root': {
      ...(open && {
        padding: '0.2rem 0.5rem',
        minWidth: '40px',
        margin: '8px 16px',
        // padding: '0.5rem',
      }),
      ...(!open && {
        margin: isMobile ? '8px 0px' : '8px 10px',
      }),
    },
    '& .MuiListItemIcon-root': {
      ...(open && {
        padding: '0.4rem 0.5rem',
        minWidth: '40px',
      }),
    },
    '& .MuiTypography-noWrap': {
      paddingLeft: open ? '32px' : isMobile ? '6px' : '16px',
    },
  };
});

function SideNav({
  open = false,
  sideNavItems = [],
  toggleSideNav = () => {},
}) {
  const navigate = useNavigate();

  return (
    <Drawer variant="permanent" open={open}>
      <Toolbar
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: [1],
        }}
      >
        <img
          src={`${constants.IMAGES_URL}/nc-logo-full-black.svg`}
          height={60}
          style={{ marginLeft: 24, paddingTop: 6, paddingBottom: 6 }}
          alt="Logo"
        />
        {/* <Typography
          color="primary"
          variant="h6"
          noWrap
          fontWeight={700}
          display="flex"
          justifyContent="flex-start"
          paddingLeft="10px"
          sx={{ flexGrow: 1 }}
        >
          Nova Circle
        </Typography> */}
        <IconButton onClick={toggleSideNav}>
          <ChevronLeftIcon />
        </IconButton>
      </Toolbar>
      <Divider />
      <List component="nav">
        <Typography
          color="grey"
          fontSize={14}
          fontWeight={600}
          noWrap
          display="flex"
          justifyContent="flex-start"
          paddingTop="10px"
          paddingBottom="10px"
          sx={{ flexGrow: 1 }}
        >
          Menu
        </Typography>
        {sideNavItems.map((item) => (
          <ListItemButton
            display="flex"
            alignItems="center"
            fontSize={14}
            key={item.name}
            sx={{
              borderRadius: '0.5rem',
            }}
            selected={window.location.pathname.startsWith(item.redirectTo)}
            onClick={() => {
              if (item.redirectTo) {
                navigate(item.redirectTo);
              }
            }}
          >
            <ListItemIcon>
              <item.icon
                color={
                  window.location.pathname.startsWith(item.redirectTo)
                    ? 'primary'
                    : 'default'
                }
              />
            </ListItemIcon>
            <ListItemText
              sx={{
                '& .MuiTypography-root': {
                  fontSize: '14px !important',
                },
                '.Mui-selected & .MuiTypography-root': {
                  fontWeight: 700,
                  color: '#002335',
                },
              }}
              primary={item.name}
            />
          </ListItemButton>
        ))}
      </List>
    </Drawer>
  );
}

export default SideNav;
